import React from "react";

/** Two-option segmented control for auth modes. */
export default function AuthModeToggle({
  value,
  onChange,
  left = { id: "magic", label: "Email link" },
  right = { id: "password", label: "Email & password" },
}) {
  const btn = (opt) => {
    const active = value === opt.id;
    return (
      <button
        key={opt.id}
        type="button"
        onClick={() => onChange?.(opt.id)}
        className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
          active
            ? "bg-white text-slate-900 shadow-sm"
            : "text-slate-600 hover:text-slate-900"
        }`}
      >
        {opt.label}
      </button>
    );
  };

  return (
    <div className="flex rounded-lg border border-slate-200 bg-slate-50 p-1">
      {btn(left)}
      {btn(right)}
    </div>
  );
}
